module.exports = __webpack_public_path__ + "static/media/4.9805c8e9.jpg";